import { DefaultCompanyBranchDivisionService } from "@/_services/api/sales/default-company-branch-dicision.service";
import { CompanyService } from "@/_services/api/accounts/company.service";
import { CacheService } from "../_services/cache/cache-service";

let localCacheCompany = undefined;

export const defaultUserSettings = {
  namespaced: true,
  state: {
    settings: {
      CompanyCode: null,
      BranchCode: null,
      DivisionCode: null,
      CurrencyCode: null,
    },
  },
  actions: {
    async setDefaultCompanyBranchDivision({ commit }) {
      var userSetting = CacheService.getCache("defaultUserSettings");

      if (!userSetting)
        return await DefaultCompanyBranchDivisionService.getDefault().then(
          async (result) => {
            if (result.data.value.length > 0) {
              commit("setCompanyCode", result.data.value[0].CompanyCode);
              commit("setBranchCode", result.data.value[0].BranchCode);
              commit("setDivisionCode", result.data.value[0].DivisionCode);

              var company = CacheService.getCache("CompanyData");
              if(!company && localCacheCompany) company = localCacheCompany;
              if (!company)
                await CompanyService.getByCompanyCode(
                  result.data.value[0].CompanyCode,
                  {
                    select: [
                      "Code",
                      "Name",
                      "CurrencyCode",
                      "Abn",
                      "Acn",
                      "TaxCode",
                      "FriendlyName",
                    ],
                  }
                ).then((res) => {
                  CacheService.saveCache(
                    "CompanyData",
                    res.data.value[0],
                    1,
                    "week"
                  );
                  localCacheCompany = res.data.value[0];
                  commit("setCurrency", res.data.value[0].CurrencyCode);
                });
              else commit("setCurrency", company.CurrencyCode);
            } else {
              CacheService.saveCache("defaultUserSettings", {}, 5);
            }
          }
        );
      else {
        commit("setCompanyCode", userSetting.CompanyCode);
        commit("setBranchCode", userSetting.BranchCode);
        commit("setDivisionCode", userSetting.DivisionCode);
        commit("setCurrency", userSetting.CurrencyCode);
        var company = CacheService.getCache("CompanyData");
        if (company) commit("setCurrency", company.CurrencyCode);
      }
    },
  },
  mutations: {
    setCompanyCode(state, companyCode) {
      state.settings.CompanyCode = companyCode;
    },
    setBranchCode(state, branchCode) {
      state.settings.BranchCode = branchCode;
    },
    setDivisionCode(state, divisionCode) {
      state.settings.DivisionCode = divisionCode;
    },
    setCurrency(state, currencyCode) {
      state.settings.CurrencyCode = currencyCode;
      CacheService.saveCache("defaultUserSettings", state.settings, 5);
    },
  },
  getters: {
    getSettings: (state) => () => {
      return state.settings;
    },

    getCurrencyCode: (state) => () => {
      return state.settings.CurrencyCode;
    },
  },
};
